export default __webpack_public_path__ + "static/questions2-fcea09a54d445be4bf8890811b637853.mp4";